import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MenuItem } from '@mui/material';

export const StyledCustomDatePickerRange = styled('div')`
  width: ${(props) => props.width};
  .text-field {
    background-color: ${COLOR.white};
    width: 100%;
    min-width: ${(props) => props.minWidth || '240px'};
    .MuiOutlinedInput-root {
      font-size: 14px;
      height: 40px;
      border-radius: 6px 0 0 6px;
      border: 1px solid #1e164e29;
      padding-left: 0 !important;
      color: ${COLOR.darkBlue} !important;
    }
  }
  .dropdown-button {
    border: 1px solid #1e164e29;
    border-left: none;
    padding: 8px;
    height: 40px;
    width: 40px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
    border-radius: 0 6px 6px 0;
  }
  #date-picker-preset-menu {
    width: 500px;
  }

  @media only screen and (max-width: 900px) {
    .text-field {
      min-width: 150px;
    }
  }
`;

export const StyledListMenuItem = styled('div')`
  padding: 8px;
  border: 1px solid #1e164e52;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000014;
`;

export const PopoverMenuItem = styled(MenuItem)`
  padding: 8px 12px;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  color: ${(props) => props.active && COLOR.darkBlue};
  background-color: ${(props) => props.active && '#1E164E14'};
  display: flex;
  gap: 10px;
  &:hover {
    color: ${(props) => (props.active ? COLOR.darkBlue : COLOR.text)};
    background-color: ${(props) =>
      props.active ? '#1E164E14' : TRANSPARENT_COLOR.dark};
  }
`;
